import { useEffect, useState } from "react"

/** The value as it stood after `ms` of quiet; tracks the latest one otherwise. */
export function useDebouncedValue<T>(value: T, ms: number): T {
	const [settled, setSettled] = useState(value)

	useEffect(() => {
		if (Object.is(value, settled)) return
		const timer = setTimeout(() => setSettled(value), ms)
		return () => clearTimeout(timer)
	}, [value, settled, ms])

	return settled
}
